export default {
  'TITLE_TAB': 'Analíticos',
  'TITLE': 'Analíticos',
  'OVERVIEW': 'Resumen de rentabilidad',
  'DATA_CAPTURED': 'Data capturada',
  'VIDEO_VIEWS': 'Campañas WiFi',
  'POLLS': 'Encuestas',
  'OVERVIEW_TOOLTIP': 'Muestra la información reportada de  usuarios registrados con un estimado de valor de mercado generado por la plataforma en los últimos 30 días',
  'DATA_CAPTURED_TOOLTIP': 'Valor estimado de captación de prospectos . El valor del dato en el mercado es de aproximadamente $50 MXN por registro',
  'VIDEO_VIEWS_TOOLTIP': 'Método de monetización por visualización de publicidad, considerando que el valor de publicidad en el mercado es de $4 MXN, se debe considerar que este valor representa una visualización real',
  'POLLS_TOOLTIP': 'Método de monetización por realizar encuestas, considerando que el valor de la respuesta en el mercado es de $16 MXN',
  'MONTHLY_CONNECTIONS': 'Conexiones mensuales',
  'UNIQUE_USERS': 'Usuarios únicos',
  'WIFI_CONSUMPTION': 'Consumo de la red WiFi',
  'BUTTON_GROUP_TITLE': 'Período de tiempo',
  'LOGIN_TYPE': 'Tipo de ingreso',
  'VISITOR_ENTRY': 'Ingreso preferido de visitantes',
  'VISITOR_ENTRY_UNIT': 'visitantes',
  'VISIT_FRECUENCY': 'Frecuencia de visitas',
  'MONTHLY_RATE': 'Tasa de retorno mensual',
  'MONTHLY_RATE_UNIT': 'ingresos totales',
  'VISIT_FRECUENCY_DETAILED': 'Conoce con que frecuencia te visitan tus clientes',
  'VISIT_FRECUENCY_LEGEND': 'Visitantes',
  'VISIT_FRECUENCY_UNIT': 'Visitantes',
  'CAMPAIGN_TITLE': 'Campañas visualizadas',
  'CAMPAIGN_TABLE_NAME': 'Nombre',
  'CAMPAIGN_TABLE_FORMAT': 'Formatos de Campaña',
  'CAMPAIGN_TABLE_STATE': 'Estado',
  'CAMPAIGN_TABLE_DELIVERY': 'Entrega',
  'CAMPAIGN_TABLE_END_DATE': 'Fecha de Término',
  'TOP_CATEGORIES': 'Top {{count}} categorías',
  'TOP_LIKES': 'Top {{count}} de preferencias',
  'TOP_CATEGORIES_TOOLTIP': 'por 30 días',
  'TOP_CATEGORIES_LEGEND': 'Categorías',
  'DEMOGRAPHICS_TITLE': 'Perfil demográfico',
  'DEMOGRAPHICS_CLIENTS': 'Demografía de los clientes',
  'GENDER_COMPARISON': 'Comparación de género',
  'GENDER_COMPARISON_UNIT': 'usuarios',
  'MALES': 'Hombres',
  'FEMALES': 'Mujeres',
  'DEFAULT_TOOLTIP_TEXT': 'por 30 días',
  'CAMPAIGN_STATUS': {
    'ACTIVE': 'Activa',
    'FINISHED': 'Finalizada',
    'ACTIVE_LABEL': 'Finaliza el {{date}}',
    'FINISHED_LABEL': 'Finalizó el {{date}}',
  },
  'CAMPAIGN_TYPES': {
    'FORM': 'Encuesta',
  },
  'CHARTS': {
    'MALE': 'Hombres',
    'FEMALE': 'Mujeres',
    'FOREIGNERS': 'Extranjeros',
    'REGISTER': 'Formulario',
    'BANK': 'Banco',
    'CODE': 'Código',
    'EMPLOYEES': 'Empleados',
    'TRAVELLERS': 'Viajantes',
    'WHITELIST': 'Lista blanca',
    'ONE_TIME': 'Una visita',
    'RETURNING': 'Múltiples visitas',
    'HOUR': 'Hora',
    'DAY': 'Día',
    'WEEK': 'Semana',
    'MONTH': 'Mes',
    'SHOW_PORTAL': 'Despliegue de portal',
    'LOGINS': 'Ingresos totales',
    'VIDEO_FINISH': 'Vistas de video',
    'UNIQUE_LOGINS': 'Ingresos únicos',
    'APP_FINISH': 'Click descarga de aplicación',
    'FORM_FINISH': 'Encuestas respondidas',
  }
}
